/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Group_MediaInputs */

const cs_draft_group_media = /** @type {(inputs: Draft_Group_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média`)
};

const en_draft_group_media = /** @type {(inputs: Draft_Group_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

/**
* | output |
* | --- |
* | "Media" |
*
* @param {Draft_Group_MediaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_group_media = /** @type {((inputs?: Draft_Group_MediaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Group_MediaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_group_media(inputs)
	return cs_draft_group_media(inputs)
});